"use client";

import { Megaphone, X } from "lucide-react";
import type { Aviso } from "@/types/avisos";

interface UrgentAvisosBannerProps {
  avisos: Aviso[];
  onDismiss: (id: number) => void;
}

export function UrgentAvisosBanner({ avisos, onDismiss }: UrgentAvisosBannerProps) {
  if (avisos.length === 0) return null;

  return (
    <div className="space-y-2">
      {avisos.map((aviso) => (
        <div
          key={aviso.id}
          className="flex items-start gap-3 rounded-2xl border border-[#ff6b2b]/30 bg-[#ff6b2b]/10 px-4 py-3.5"
        >
          <div className="mt-0.5 flex size-7 shrink-0 items-center justify-center rounded-full bg-[#ff6b2b]/20">
            <Megaphone className="size-3.5 text-[#ff6b2b]" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-13 font-semibold text-foreground">{aviso.titulo}</p>
            <p className="mt-0.5 text-13 leading-snug text-muted-foreground">{aviso.mensagem}</p>
          </div>
          <button
            type="button"
            onClick={() => onDismiss(aviso.id)}
            aria-label="Dispensar aviso"
            className="mt-0.5 shrink-0 rounded-full p-1 text-muted-foreground transition-colors hover:bg-[#ff6b2b]/20 hover:text-[#ff6b2b]"
          >
            <X className="size-3.5" />
          </button>
        </div>
      ))}
    </div>
  );
}
